import { Injectable } from '@angular/core';
import { TableService } from '../table.service';
import { TableObject } from 'src/app/models/tableObject';
import { Observable } from 'rxjs';
import { TopFlopStore } from './top-flop.store';
import { TopFlop } from 'src/app/models/topflop';
import { Sort } from '@angular/material/sort';
import { ApiService } from '../api-service';
import { ConstantsStore } from '../constants.store';
import { TopFlopAll } from 'src/app/models/TopFlopAll';

@Injectable({
  providedIn: 'root'
})
export class TopFlopService {

  constructor(
    private api: ApiService,
    private constants: ConstantsStore,
    private store: TopFlopStore,
    private tableService: TableService
  ) { }

  get(pageNumber: number = 1, pageSize: number = 10, filter: string = null, ascending: boolean = null): Observable<any> {
    this.store.showLoader = true;
    return new Observable(observer => {
      this.tableService.getTopFlopRecords(pageNumber, pageSize, filter, ascending)
        .subscribe(
          (res: TableObject<TopFlopAll>) => {
            this.store.totalRecords = res.totalRecords;
            this.store.loadAll(res.records);
            this.store.showLoader = false;

            observer.next(res.records);
          },
          (err) => {
            observer.error(err);
           this.store.showLoader = false;

          },
          () => { }
        );
    });
  }

  getSummary(): Observable<boolean> {
    this.store.showLoader = true;
    return new Observable(observer => {
      this.getTopFlopRecords()
        .subscribe(
          (res: TopFlop[]) => {
            this.store.totalRecords = 10;
            this.store.load(res);
            this.store.showLoader = false;

            observer.next(true);
          },
          (err) => {
            observer.error(err);
           this.store.showLoader = false;

          },
          () => { }
        );
    });
  }

  sorting(sort: Sort) {
    const data = this.store.records.slice();

    if (!sort.active || sort.direction === '') {
      this.store.sortedRecords = data;
      return;
    }

    this.store.sortedRecords = data.sort((a, b) => {
      const isAsc = sort.direction === 'asc';
      switch (sort.active) {
        case 'Sottostante': return this.compare(a.sottostante, b.sottostante, isAsc);
        case 'Ultimo': return this.compare(a.ultimo, b.ultimo, isAsc);
        case 'Var%': return this.compare(a.var, b.var, isAsc);
        default: return 0;
      }
    });
  }

  compare(a: number | string | Date, b: number | string | Date, isAsc: boolean) {
    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }

  getTopFlopRecords() {
    return this.api.get<TopFlop[]>(this.constants.topFlopUrl);
  }
}
